import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Svg } from 'src/Components'

import styles from './BotHeadSpin.module.scss'

const BotHeadSpin = ({ className, panelSpacing, ...restProps }) => (
  <div
    className={classnames(
      styles.root,
      panelSpacing && styles.inPanel,
      className
    )}
    {...restProps}
  >
    <Svg viewBox='0 0 33 33' xmlns='http://www.w3.org/2000/svg'>
      <g fill='none'>
        <path
          fill='#FFF'
          d='M17.751 16.338a1.98 1.98 0 0 0 1.981 1.979 1.98 1.98 0 1 0 0-3.959 1.98 1.98 0 0 0-1.98 1.98zm-6.426 0a1.98 1.98 0 0 0 1.981 1.979 1.98 1.98 0 1 0 0-3.959 1.98 1.98 0 0 0-1.981 1.98zm2.23 7.3h-2.168c-.71 0-1.286-.577-1.286-1.286v-2.18h-.765a.693.693 0 0 1-.693-.692v-2.8c0-.382.31-.692.693-.692h.765v-2.745c0-.71.576-1.285 1.286-1.285h4.745v-.786a2.032 2.032 0 0 1 .406-4.022 2.033 2.033 0 0 1 .324 4.037v.771h4.76c.71 0 1.287.576 1.287 1.285v2.745h.754c.384 0 .694.31.694.692v2.8c0 .382-.31.692-.694.692h-.754v2.18c0 .71-.577 1.285-1.287 1.285h-8.068zm-.9-3.492a.848.848 0 0 0-.854.848c0 .468.389.847.853.847h7.91a.848.848 0 0 0 .853-.847.855.855 0 0 0-.853-.848h-7.91z'
        />
      </g>
    </Svg>
  </div>
)

BotHeadSpin.propTypes = {
  className: PropTypes.string,
  panelSpacing: PropTypes.bool
}

export default BotHeadSpin
